import { Text } from '@chakra-ui/react';
import Link from 'next/link';
import { LabelButton, SubmitButton } from '@/components';
import { FooterButtonLayout } from '@/components/Footer/FooterButtonLayout/FooterButtonLayout';
import { getPageInfo } from '@/config/pages';
import {
  ShopObject
} from '@/graphql/generated/graphql';

export type SpShopDetailSubmitFooterProps = {
  shop: Pick<ShopObject, 'isBookable' | 'tel' | 'slug' | 'name'>;
}

export const SpShopDetailSubmitFooter = ({
  shop
}: SpShopDetailSubmitFooterProps) => {
  const { isBookable, tel } = shop;
  if (!isBookable) return null;

  return (
    <FooterButtonLayout>
      {isBookable &&
        <>
          {tel &&
            <SubmitButton
              w={'49%'}
              size={'lg'}
              as={'a'}
              href={`tel:${tel}`}
              rel={'noreferrer'}
              color={'brand.500'}
              bg={'white'}
              variant={'outline'}
              borderColor={'brand.500'}
            >
              <Text>電話予約する</Text>
            </SubmitButton>
          }
          <LabelButton
            bg={'brand.500'}
            color={'white'}
            borderColor={'brand.500'}
            width={'49%'}
            height={'48px'}
            borderRadius={'50px'}
            px={6}
          >
            <Link
              href={getPageInfo('studio/{slug}/booking', shop).href}
            >
              <Text
                fontWeight={'bold'}
                textStyle={'h4'}
                pt={'1px'}
              >
                WEB予約する
              </Text>
            </Link>
          </LabelButton>
        </>
      }
    </FooterButtonLayout>
  );
};
